
<template>
  <div ref="waterfall">
  </div>
</template>

<script>
  import { throttle } from "throttle-debounce";
  export default {
    name: "Waterfall",
    props: {
      list:Array,
      form:Object,
      dataList:Function
    },
    data() {
      return {
        isLoading: false,
      };
    },
    mounted() {

      // 性能优化：节流，每隔一段固定的时间，再去执行指定的功能
      this.loading = throttle(300, this.scroll.bind(this));
      window.addEventListener("scroll", this.loading);
    },
    destroyed() {
      // 防止组件被解绑之后，监听事件依然存在，需要解绑
      window.removeEventListener("scroll", this.loading);
    },
    methods: {
      scroll() {
        if (this.isLoading) return;
        // getBoundingClientRect()：获取元素的位置
        if (
          this.$refs.waterfall.getBoundingClientRect().bottom >
          document.documentElement.clientHeight
        ) {

          this.isLoading = true;
          // 通知外部，滚动已完成，可以显示数据
          //this.$emit("view");
          if(this.list.length !== 0)
          {
            this.form.page ++;
            this.dataList()
          }


        }
      },
    },
  };

</script>
